export function linksList(links) {
  return Object.entries(links).map(([key, value]) => (
    <span className="links-list-item">
      <a href={value} target="_blank" rel="noopener noreferrer">
        {key}
      </a>
    </span>
  ));
}
